/**
 * Fix Add to Cart Button - Remove price from button text
 * This script runs after variant-picker.js and removes the price from the ATC button
 */

(function() {
  'use strict';

  function removeATCPrice() {
    const atcButtons = document.querySelectorAll('.m-add-to-cart--text');
    atcButtons.forEach(btn => {
      const text = btn.textContent;
      // Remove price from button text (format: "Add to cart – €XX" or "Add to cart - €XX")
      if (text.includes('–') || text.includes('-')) {
        btn.textContent = window.MinimogStrings?.addToCart || 'Add to cart';
      }
    });
  }

  // Run after any variant change
  function init() {
    // Initial cleanup
    setTimeout(removeATCPrice, 600);
    
    // Watch for button text changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          const text = mutation.target.textContent || '';
          if (text.includes('–') || (text.includes('-') && text.includes('€'))) {
            setTimeout(removeATCPrice, 50);
          }
        }
      });
    });

    // Observe all ATC buttons
    document.querySelectorAll('.m-add-to-cart--text').forEach(btn => {
      observer.observe(btn, { characterData: true, childList: true, subtree: true });
    });

    // Also listen for clicks on variant pickers
    document.addEventListener('click', (e) => {
      if (e.target.closest('variant-picker') || 
          e.target.closest('.m-product-option') ||
          e.target.closest('[data-option-value]')) {
        setTimeout(removeATCPrice, 300);
        setTimeout(removeATCPrice, 600);
      }
    });
  }

  // Start after page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 700));
  } else {
    setTimeout(init, 700);
  }

  // Re-init on Shopify section render (theme editor)
  document.addEventListener('shopify:section:load', () => setTimeout(init, 700));
})();
